<template>
  <div>
    <b-sidebar
      id="sidebar-right"
      ref="mySidebar"
      bg-variant="white"
      v-model="visibility"
      sidebar-class="sidebar-lg"
      right
      no-header
      backdrop
      shadow
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">Gate Pass</h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="visibility = false"
        />
      </div>
      <b-form class="p-2" @submit.prevent>
        <b-row>
          <b-col md="12">
            <b-form-group
              label="Issue Date"
              invalid-feedback="Issue Date is required"
              ref="issue_date"
            >
              <flat-pickr
                :config="config"
                v-model="myObj.issuedOn"
                class="form-control"
                :placeholder="$t('Select Date')"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              label="Return Date"
              invalid-feedback="Return Date is required"
              ref="return_date"
            >
              <flat-pickr
                :config="config"
                v-model="myObj.returnDate"
                class="form-control"
                :placeholder="$t('Select Date')"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              label="Note"
              invalid-feedback="Note is required"
              ref="note"
            >
              <b-form-textarea
                placeholder="Enter note here"
                v-model.trim="myObj.note"
              ></b-form-textarea>
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-row class="mb-1">
              <b-col md="6"> Product </b-col>
              <b-col md="6"> Quantity </b-col>
            </b-row>

            <b-row v-for="(item, index) in details" :key="index" class="mb-50">
              <b-col md="6">
                <v-select
                  v-model="item.productID"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="products"
                  :reduce="(val) => val.id"
                  label="name"
                  :selectable="
                    (opt) => !details.some((item) => item.productID === opt.id)
                  "
                  :clearable="false"
                  placeholder="Choose product"
                />
              </b-col>
              <b-col md="4">
                <b-form-input
                  type="number"
                  v-model="item.quantity"
                  placeholder="Enter quantity"
                >
                </b-form-input>
              </b-col>
              <b-col md="2">
                <b-button
                  v-if="index == details.length - 1"
                  variant="outline-primary"
                  class="btn-icon"
                  pill
                  size="sm"
                  @click="addDetails()"
                >
                  <feather-icon icon="PlusIcon" />
                </b-button>
                <b-button
                  v-else
                  variant="outline-danger"
                  class="btn-icon"
                  pill
                  size="sm"
                  @click="removeDetail(index)"
                >
                  <feather-icon icon="Trash2Icon" />
                </b-button>
              </b-col>
            </b-row>
          </b-col>

          <b-col md="12" class="mt-2">
            <b-button
              variant="success"
              block
              @click="savePass()"
              :disabled="request"
            >
              <b-spinner v-if="request" small type="grow" />
              <span v-else>{{$t('Save')}}</span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-sidebar>

    <b-sidebar
      id="sidebar-settle"
      ref="mySidebar"
      bg-variant="white"
      v-model="visibility2"
      sidebar-class="sidebar-lg"
      right
      no-header
      backdrop
      shadow
      width="450px"
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">Gate Pass</h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="visibility2 = false"
        />
      </div>
      <b-form class="p-2" @submit.prevent v-if="detailObj.pass">
        <b-row class="mb-1">
          <b-col md="12">
            <h5 class="font-weight-bolder mb-0">
              Pass ID: {{ detailObj.pass.id }}
            </h5>
            <hr />
            <div>
              Issued On:
              <b-badge variant="light-primary" class="ml-1">
                {{
                  new Date(detailObj.pass.issuedOn).toLocaleDateString(
                    "en-UK",
                    {
                      year: "numeric",
                      day: "numeric",
                      month: "short",
                    }
                  )
                }}
              </b-badge>
            </div>
            <div>
              Return Date:
              <b-badge
                variant="light-primary"
                class="ml-1"
                v-if="detailObj.pass.returnDate"
              >
                {{
                  new Date(detailObj.pass.returnDate).toLocaleDateString(
                    "en-UK",
                    {
                      year: "numeric",
                      day: "numeric",
                      month: "short",
                    }
                  )
                }}
              </b-badge>
            </div>
            <div>
              Returned On:
              <b-badge
                variant="light-primary"
                class="ml-1"
                v-if="detailObj.pass.returnedOn"
              >
                {{
                  new Date(detailObj.pass.returnedOn).toLocaleDateString(
                    "en-UK",
                    {
                      year: "numeric",
                      day: "numeric",
                      month: "short",
                    }
                  )
                }}
              </b-badge>
            </div>
            <div>
              Status:
              <b-badge
                :variant="
                  detailObj.pass.status == 'returned'
                    ? 'light-success'
                    : 'light-primary'
                "
              >
                {{ detailObj.pass.status }}
              </b-badge>
            </div>
            <hr />
          </b-col>
          <b-col md="12">
            <ul class="list-unstyled">
              <li
                class="d-flex justify-content-between mb-25"
                v-for="(item, ind) in detailObj.details"
                :key="item.id"
              >
                <div class="">
                  <span class=""
                    >{{ getProduct(item.productID) }} ({{
                      item.quantity
                    }})</span
                  >
                </div>
              </li>
            </ul>
          </b-col>
        </b-row>
      </b-form>
    </b-sidebar>

    <b-modal id="modal-return" title="Mark as Returned" centered>
      <b-form @submit.prevent v-if="returnObj.id">
        <b-form-group
          label="Return Date"
          invalid-feedback="Date is required"
          ref="return_on"
        >
          <flat-pickr
            :config="config"
            v-model="returnObj.returnedOn"
            class="form-control"
            placeholder="Select return date"
          />
        </b-form-group>

        <b-form-group
          label="Note"
          invalid-feedback="Note is required"
          ref="return_note"
        >
          <b-form-textarea
            placeholder="Enter note here"
            v-model.trim="returnObj.returnNote"
          ></b-form-textarea>
        </b-form-group>
      </b-form>
      <template #modal-footer>
        <b-button variant="primary" @click="saveReturn()" :disabled="returning">
          <b-spinner small v-if="returning" class="mr-25" />
          <span>Save</span>
        </b-button>
      </template>
    </b-modal>

    <b-card>
      <b-row>
        <b-col xl="2" lg="3" md="4">
          <b-button variant="primary" block @click="addOpen()">
            <feather-icon icon="PlusIcon" class="mr-50" />
            <span>Gate Pass</span>
          </b-button>
        </b-col>
      </b-row>
      <b-table
        class="mt-1"
        :items="items"
        :fields="fields"
        :busy="dataLoading"
        responsive
        show-empty
      >
        <template #table-busy>
          <div class="d-flex justify-content-center mb-3 mt-5">
            <b-spinner
              type="grow"
              variant="primary"
              label="Spinning"
            ></b-spinner>
          </div>
        </template>

        <template #cell(id)="data">
          <b-badge variant="light-primary">
            {{ data.item.pass.id }}
          </b-badge>
        </template>
        <template #cell(issuedOn)="data">
          <b-badge variant="light-primary">
            {{
              new Date(data.item.pass.issuedOn).toLocaleDateString("en-UK", {
                year: "numeric",
                day: "numeric",
                month: "short",
              })
            }}
          </b-badge>
        </template>
        <template #cell(returnedOn)="data">
          <b-badge variant="light-primary" v-if="data.item.pass.returnedOn">
            {{
              new Date(data.item.pass.returnedOn).toLocaleDateString("en-UK", {
                year: "numeric",
                day: "numeric",
                month: "short",
              })
            }}
          </b-badge>
        </template>
        <template #cell(status)="data">
          <b-badge
            :variant="
              data.item.pass.status == 'returned'
                ? 'light-success'
                : 'light-primary'
            "
          >
            {{ data.item.pass.status }}
          </b-badge>
        </template>

        <template #cell(actions)="data">
          <b-button
            variant="primary"
            class="btn-icon"
            v-b-tooltip.hover.left
            title="Print"
            @click="printPass(data.item.pass)"
          >
            <feather-icon icon="PrinterIcon" />
          </b-button>
          <b-button
            variant="primary"
            class="btn-icon ml-1"
            v-b-tooltip.hover.left
            title="View"
            @click="viewDetails(data.item)"
          >
            <feather-icon icon="EyeIcon" />
          </b-button>
          <b-button
            v-if="data.item.pass.status == 'pending'"
            variant="outline-success"
            class="btn-icon ml-1"
            v-b-tooltip.hover.left
            title="Mark as Returned"
            @click="openReturned(data.item)"
          >
            <feather-icon icon="CheckIcon" />
          </b-button>
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BBadge,
  BPagination,
  BImg,
  BFormCheckbox,
  BFormGroup,
  BForm,
  BSpinner,
  BSidebar,
  BFormTextarea,
  VBTooltip,
} from "bootstrap-vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { mapActions } from "vuex";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BBadge,
    BPagination,
    BImg,
    BFormCheckbox,
    BFormGroup,
    BForm,
    BSpinner,
    BSidebar,
    BFormTextarea,
    vSelect,
    flatPickr,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  data() {
    return {
      config: {
        altFormat: "j M, Y",
        altInput: true,
        dateFormat: "Y-m-d\\TH:i:S",
      },
      dataLoading: false,
      request: false,
      visibility: false,
      myObj: {},
      details: [],
      products: [],
      items: [],
      fields: [
        { label: "id", key: "id" },
        { label: "issued on", key: "issuedOn" },
        { label: "returned on", key: "returnedOn" },
        // { label: "issued by", key: "issuedBy" },
        { label: "status", key: "status" },
        "actions",
      ],
      visibility2: false,
      detailObj: {},
      returning: false,
      returnObj: {},
      reportDomain: this.$store.state.report.replace(/_/g, ""),
    };
  },
  created() {
    this.LoadProduct();
    this.LoadData();
  },
  methods: {
    ...mapActions({ get: "get", post: "post", put: "put", delete: "delete" }),

    getProduct(id) {
      let obj = this.products.find((el) => el.id == id);
      return obj ? obj.name : "";
    },

    printPass(item) {
      let url =
        `https://${this.reportDomain}.myskool.app/Inventory/GatePass?dbb=` +
        this.$store.state.userData.db +
        "&cID=" +
        item.campusID +
        "&passID=" +
        item.id;

      window.open(url, "_blank");
    },

    viewDetails(item) {
      this.detailObj = { ...item };
      this.visibility2 = true;
    },

    addOpen() {
      this.myObj = {
        id: 0,
        issuedOn: new Date().toJSON(),
        returnDate: null,
        returnedOn: null,
        issuedBy: this.$store.state.userData.userID,
        returnedBy: 0,
        status: "pending",
        note: "",
        returnNote: "",
        campusID: this.$store.state.userData.cId,
      };
      this.details = [];
      this.addDetails();
      this.visibility = true;

      let elem = this.$refs["issue_date"];
      elem.state = undefined;
    },
    async addDetails() {
      this.details.push({
        id: 0,
        passID: this.myObj.id,
        productID: 0,
        quantity: 0,
        note: "",
        campusID: this.$store.state.userData.cId,
      });
    },
    async removeDetail(ind) {
      this.details.splice(ind, 1);
    },
    CheckDetails() {
      let state = true;
      this.details.forEach((el) => {
        let x = parseInt(el.quantity);
        if (el.productID == 0 || isNaN(x) || x <= 0) {
          state = false;
        } else el.quantity = x;
      });
      return state;
    },
    CheckDate() {
      var elem = this.$refs["issue_date"];
      if (!this.myObj.issuedOn) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    async savePass() {
      let s1 = this.CheckDate();
      let s2 = this.CheckDetails();
      if (s1 && s2) {
        this.request = true;

        if (this.myObj.returnDate == "") this.myObj.returnDate = null;
        const payload = {
          pass: this.myObj,
          details: this.details,
        };

        var status = await this.post({
          url:
            this.$store.state.domain +
            "posGatePass/SavePass?db=" +
            this.$store.state.userData.db,
          body: payload,
          message: "Gate pass added successfully.",
          context: this,
          token: this.$store.state.userData.token,
        });
        this.request = false;
        if (status) {
          this.visibility = false;
          this.LoadData();
        }
      } else {
        this.$bvToast.toast("Please fill the details correctly!", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      }
    },

    openReturned(item) {
      this.returnObj = { ...item.pass };
      this.$bvModal.show("modal-return");
    },
    checkReturnDate() {
      var elem = this.$refs["return_on"];
      if (!this.returnObj.returnedOn) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    async saveReturn() {
      const s1 = this.checkReturnDate();
      if (s1) {
        this.returning = true;
        this.returnObj.status = "returned";
        this.returnObj.returnedBy = this.$store.state.userData.userID;

        var status = await this.put({
          url:
            this.$store.state.domain +
            "posGatePass/" +
            this.returnObj.id +
            "?db=" +
            this.$store.state.userData.db,
          message: "Requisition updated successfully!",
          context: this,
          body: this.returnObj,
          token: this.$store.state.userData.token,
        });
        this.returning = false;
        if (status) {
          this.LoadData();
          this.$bvModal.hide("modal-return");
        }
      } else {
        this.$bvToast.toast("Please enter the return date.", {
          title: this.$t("Error!"),
          variant: "danger",
        });
      }
    },

    async LoadProduct() {
      const obj = {
        url:
          this.$store.state.domain +
          "posStock?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.products = await this.get(obj);
    },
    async LoadData() {
      this.dataLoading = true;
      const obj = {
        url:
          this.$store.state.domain +
          "posGatePass/LoadData?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.items = await this.get(obj);
      this.dataLoading = false;
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
